import { Box, Row, Text } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';

const LOGO_HEIGHT = 20;
const PRESET = 'square-256';

const createLogoUrl = (baseUrl: string, dpr: number) => {
  const params = new URLSearchParams({
    preset: PRESET,
    service: 'cosmos',
    dpr: `${dpr}`,
  });
  return `${baseUrl}?${params.toString()}`;
};

const FORBES_LOGO_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903565-83391.png';

const FORTUNE_LOGO_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903560-61291.png';

const NEW_YORK_TIMES_LOGO_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903555-88900.png';

const WALL_STREET_JOURNAL_LOGO_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903562-10942.png';

const PRESS_LOGOS = [
  NEW_YORK_TIMES_LOGO_URL,
  FORBES_LOGO_URL,
  WALL_STREET_JOURNAL_LOGO_URL,
  FORTUNE_LOGO_URL,
];

export const PressBox = (props: BoxProps) => {
  return (
    <Box justifyContent="center" width="100%" $largerThanMD={{ width: 'auto' }}>
      <Row
        flexWrap="wrap"
        columnGap="$6x"
        padding="$10x"
        alignItems="center"
        justifyContent="center"
        width="100%"
        borderRadius={0}
        $largerThanSM={{
          borderRadius: 20,
          width: 'unset',
        }}
        style={{
          backgroundColor: 'rgba(242, 241, 240, 0.64)',
          backdropFilter: 'blur(20px)',
        }}
        {...props}
      >
        <Row
          alignItems="center"
          justifyContent="center"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, max-content)',
            gap: '24px',
            width: '100%',
            justifyItems: 'center',
          }}
        >
          <Text
            tag="span"
            typography="$bodyMedium"
            color="$contentStateInactivePrimary"
            $smallerThanMD={{ width: '100%', textAlign: 'center' }}
          >
            Featured in:
          </Text>
          {PRESS_LOGOS.map((photoUrl) => {
            const srcSet = [
              `${createLogoUrl(photoUrl, 1)} 1x`,
              `${createLogoUrl(photoUrl, 2)} 2x`,
              `${createLogoUrl(photoUrl, 3)} 3x`,
            ].join(', ');
            return (
              <Box
                key={photoUrl}
                height={LOGO_HEIGHT}
                width="auto"
                display="flex"
                justifyContent="center"
              >
                {/* eslint-disable-next-line @opendoor/no-html-elements*/}
                <img
                  src={createLogoUrl(photoUrl, 1)}
                  srcSet={srcSet}
                  alt=""
                  style={{ height: '100%', width: 'auto', objectFit: 'contain' }}
                />
              </Box>
            );
          })}
        </Row>
      </Row>
    </Box>
  );
};
